import React, { useState, useEffect } from 'react';
import queryString from 'query-string';

// import Home from './Home';
// import About from './About';
// import Blog from './Blog';
import Article from './Article';
import ERROR from '../composant/Errors';

async function fetchData(api) {
    const response = await fetch(`https://cdn-orchidee.onrender.com/api/${api}?publicationState=preview&filters[publishedAt][$null]=true&populate=deep`);
    const data = await response.json();
    return data;
}

const API = () => {
    const values = queryString.parse(document.location.search);

    var content = null;

    const [data, setData] = useState(null);

    /*eslint-disable */

    //suppress all warnings between comments
    useEffect(() => {
        fetchData(values.page).then((val) => {
            setData(val);
        });
    }, []);
    /*eslint-enable */

    // console.log(values);

    switch(values.page){
        case 'articles':
            content = (<Article api={data} uid={values.id}></Article>);
            break;
        case 'article':
            content = (<Article api={data} uid={values.id}></Article>);
            break;
        case 'teams':
            content = (<Article api={data}></Article>);
            break;
        default:
            content = (<ERROR messsage={'ERROR il n\'as rien a voir ici 👀'} color={'blue'}></ERROR>);
    }

    return (
        <div>
        {data ? (content) : (
            <p>Chargement des données en cours...</p>
        )}
        </div>
    );
}

export default API;
